// export const hostUrl = 'http://192.168.0.103:8081'; // http://192.168.0.103:8081 https://stage-reading-api.seeso.io
// export const hostUrl = 'http://192.168.0.19:8081'; // http://192.168.0.103:8081 https://stage-reading-api.seeso.io
export const hostUrl = 'https://readable-release.visualcamp.net';

// export const hostUrl = 'http://localhost:8080';
// export const hostUrl = 'http://192.168.0.14:8081';

export const tmp = '';
